export default __webpack_public_path__ + "static/media/My project - 2023-05-17T162732.106.c4423add.png";